var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-link',{attrs:{"to":"myhealth"}},[_vm._v("To app")]),_c('b-link',{attrs:{"to":"login"}},[_vm._v("Log in")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }